export default {
      id: "koyko-usage",
      viewBox: "0 0 43 43",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#koyko",
      toString: function () {
        return this.url;
      }
    }